export default "__VITE_ASSET__D_cW1l1I__"